import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { Classifier } from '../../models';

@Component({
    templateUrl: './upsert-classifier.component.html',
    styleUrls: ['./upsert-classifier.component.scss'],
})
export class UpsertClassifierComponent implements OnInit {
    @Input()
    classifier: Classifier = {} as Classifier;

    @Input()
    edit: boolean = true;

    constructor(protected ref: NbDialogRef<UpsertClassifierComponent>) {}

    ngOnInit() {}

    submitClassifier(): void {
        this.ref.close(this.classifier);
    }

    dismiss() {
        this.ref.close();
    }
}
